export default "__VITE_ASSET__CwbFusHB__"